import { Illustration, NoDataFound } from '@fabric-ui/components';
import { refetchingStyle } from '@fabric-ui/theme';
import { Button } from '@mui/material';
import Pluralize from 'pluralize';

export const TicketsNoDataFoundDefault = ({ projDisplayName, isRefetching, clearAllFilters }) => (
  <NoDataFound
    headline={`No ${Pluralize(projDisplayName)} Found`}
    img={<Illustration.Medium.NoData />}
    style={isRefetching ? { containerStyle: refetchingStyle } : {}}
    callToAction={
      <>
        Try to{' '}
        <Button variant="primaryText" onClick={() => clearAllFilters(false, true)}>
          Clear All filters
        </Button>
      </>
    }
  />
);
